document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.er-showcase').forEach(function (root) {
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-er-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-er-dot]'));
    var content = root.querySelector('[data-er-content]');
    if (!thumbs.length || !content) return;

    var modelEl = content.querySelector('[data-er-model]');
    var imageEl = content.querySelector('[data-er-image]');
    var priceEl = content.querySelector('[data-er-price]');
    var descEl = content.querySelector('[data-er-desc]');
    var shopEl = content.querySelector('[data-er-shop]');
    var shopPrefix = (shopEl && shopEl.textContent.split(' ')[0]) || 'Shop';
    var current = 0;

    function render(index) {
      var t = thumbs[index];
      if (!t) return;
      if (modelEl) modelEl.textContent = t.dataset.model;
      if (imageEl) {
        imageEl.removeAttribute('srcset');
        imageEl.removeAttribute('sizes');
        imageEl.setAttribute('src', t.dataset.image);
        imageEl.setAttribute('alt', t.dataset.model);
      }
      if (priceEl) priceEl.textContent = t.dataset.price;
      if (descEl) descEl.textContent = t.dataset.desc;
      if (shopEl) {
        shopEl.setAttribute('href', t.dataset.url);
        shopEl.textContent = shopPrefix + ' ' + t.dataset.model;
      }
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (th, i) {
        th.classList.toggle('is-active', i === index);
      });
      current = index;
    }

    var prevBtn = root.querySelector('[data-er-prev]');
    var nextBtn = root.querySelector('[data-er-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        render((current - 1 + thumbs.length) % thumbs.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        render((current + 1) % thumbs.length);
      });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        render(i);
      });
    });
  });
});
